import React, { FC } from 'react';
import { EditCreateLoad } from '../../edit-create-load/edit-create-load';
import { typedCreateLoad } from '../../utils/typed-create-load';
import { useCompanyId } from '../../../../app/agistics-context';

interface Step2CreateDefaultProps {
    onBack: () => void;
    onSubmit: () => void;
}

export const Step2CreateDefault: FC<Step2CreateDefaultProps> = (props) => {
    const { onBack, onSubmit } = props;
    const companyId = useCompanyId();

    const newLoad = typedCreateLoad(companyId, true);

    return (
        <EditCreateLoad
            inputLoad={newLoad}
            onSubmit={onSubmit}
            onBack={onBack}
        />
    );
};
